module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-06-157d5f0bfe260a6d45a323501577a8da.webp";